module.exports = __webpack_public_path__ + "img/best_value_box.9029a0d7.png";